// course data service
import httpApi from '../httpApi';

class CourseService {
	// api calls
	getCourses() {
		return httpApi.get('/courses');
	}
	
	getCourse(id) {
		return httpApi.get('/courses/'+id);
	}
	
	getUserCourses() {
		return httpApi.get('/courses/user');
	}
	
	getCertificate(id) {
		return httpApi.get('/courses/certificate/'+id);
	}
	
	getCourseDuplicationOpts(organisationId) {
		return httpApi.get('/courses/organisation/'+organisationId);
	}
	
	createCourse(data) {
		return httpApi.put('/courses', data);
	}
	
	cloneCourse(data) {
		return httpApi.put('/courses/clone/course', data);
	}
	
	cloneSection(data) {
		return httpApi.put('/courses/clone/section', data);
	}
	
	cloneLesson(data) {
		return httpApi.put('/courses/clone/lesson', data);
	}	
	
	updateCourse(data) {
		return httpApi.post('/courses', { course: data });
	}
	
	archiveCourse(data) {
		return httpApi.post('/courses/archive', data);
	}
	
	createCourseActivity(data) {
		return httpApi.put('/courses/activity', data);
	}
	
	updateCourseActivity(data) {
		return httpApi.post('/courses/activity', data);
	}
	
	deleteCourseActivity(data) {
		return httpApi.patch('/courses/activity', data);
	}
	
	deleteAllCourseActivity(courseId) {
		return httpApi.delete('/courses/activity/'+courseId);
	}
//	get(id) {
//		return httpApi.get(`/courses/${id}`);
//	}
}

export default new CourseService();
